module.exports = __webpack_public_path__ + "img/JDC_cny_trailer.4bda4861.jpg";